import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { withStateHandlers } from 'recompose';
import { Button, ButtonToolbar, Clearfix, Modal } from 'react-bootstrap';
import { getDepartmentName, getDistrictName } from '../selectors';

export const confirmZeroOutModalPropTypes = {
  openConfirmZeroOutModal: PropTypes.func.isRequired,
  closeConfirmZeroOutModal: PropTypes.func.isRequired,
  showConfirmZeroOutModal: PropTypes.bool.isRequired,
};


export const withConfirmZeroOutModalState = withStateHandlers(
  (props) => { return { showConfirmZeroOutModal: false }; },
  {
    openConfirmZeroOutModal: (state, props) => {
      return () => { return { showConfirmZeroOutModal: true }; };
    },
    closeConfirmZeroOutModal: (state, props) => {
      return () => { return { showConfirmZeroOutModal: false }; };
    },
  },
);


const propTypes = exact({
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  confirmFinalize: PropTypes.func.isRequired,
  districtName: PropTypes.string,
  departmentName: PropTypes.string,
});


const ConfirmZeroOutModal = (props) => {
  const { show, onHide, confirmFinalize, districtName, departmentName } = props;

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Zero out and Finalize {districtName} {departmentName}?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to
        zero out and finalize {districtName} - {departmentName}?
        <Clearfix>
          <ButtonToolbar className="pull-right">
            <Button
              bsStyle="warning"
              onClick={onHide}
            >
              Close
            </Button>
            <Button
              bsStyle="primary"
              onClick={confirmFinalize}
            >
              Confirm
            </Button>
          </ButtonToolbar>
        </Clearfix>
      </Modal.Body>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    districtName: getDistrictName(state),
    departmentName: getDepartmentName(state),
  };
};

ConfirmZeroOutModal.propTypes = propTypes;

const withRedux = connect(mapStateToProps, {});

export default withRedux(ConfirmZeroOutModal);
